import React, { useState } from 'react';
import SentientOrb from '../orb/SentientOrb.tsx';
import { SignInChat, SignUpChat, SignUpFormChat } from '../orb/SentientOrbChat.tsx';

function OnboardLeftSection({
    onClose,
    loading = false,
    mode = 'signin',
    signUpStage = 'welcome',
    onChatStreamComplete,
    onChatStreamStart,
    onYesClick,
    onNoClick,
    showLearnMore = false,
    onLearnMoreClick
}) {
    const [isStreaming, setIsStreaming] = useState(false);

    const handleStreamStart = () => {
        setIsStreaming(true);
        if (onChatStreamStart) onChatStreamStart();
    };

    const handleStreamComplete = () => {
        setIsStreaming(false);
        if (onChatStreamComplete) onChatStreamComplete();
    };

    return (
        <div className="signin-left-section">
            {onClose && (
                <button className="back-button-left" onClick={onClose} disabled={loading}>
                    ← Back
                </button>
            )}
            <div className="orb-container">
                <SentientOrb
                    color="#001a33"
                    action={isStreaming ? 'talk' : 'idle'}
                />
            </div>
            <div className="orb-chat">
                {mode === 'signup' ? (
                    <SignUpChat
                        stage={signUpStage}
                        onStreamComplete={handleStreamComplete}
                        onStreamStart={handleStreamStart}
                        onYesClick={onYesClick}
                        onNoClick={onNoClick}
                        isStreaming={true}
                    />
                ) : mode === 'signupForm' ? (
                    <SignUpFormChat
                        onStreamComplete={handleStreamComplete}
                        onStreamStart={handleStreamStart}
                        isStreaming={true}
                    />
                ) : (
                    <SignInChat
                        stage="welcome"
                        onStreamComplete={handleStreamComplete}
                        onStreamStart={handleStreamStart}
                        isStreaming={true}
                    />
                )}
            </div>
            {showLearnMore && onLearnMoreClick && (
                <button className="learn-more-btn" onClick={onLearnMoreClick}>
                    Learn more
                </button>
            )}
        </div>
    );
}

export default OnboardLeftSection;

